import { errorMaxLength, inputDescription } from "_constants";
import { InputTextarea } from "primereact/inputtextarea";
import { Control, Controller } from "react-hook-form";

export const FormSendAnswerFeedback = ({
  control,
}: {
  control: Control<
    { projectId: string; answerId: string; description: string },
    any
  >;
}) => {
  return (
    <>
      <div className="flex-column">
        <Controller
          name="description"
          control={control}
          rules={{
            maxLength: {
              value: 8192,
              message: `${errorMaxLength} ${8192}`,
            },
          }}
          render={({ field, fieldState: { error } }) => {
            return (
              <div className="flex-container column">
                <InputTextarea
                  id={field.name}
                  {...field}
                  className={`width-100 ${
                    error ? "p-invalid margin-bottom-4" : ""
                  }`}
                  placeholder={inputDescription}
                  rows={5}
                />
                {error && (
                  <small className="p-error margin-bottom-4">
                    {error.message}
                  </small>
                )}
              </div>
            );
          }}
        />
      </div>
    </>
  );
};
